import history from '../routers/history'
import store from 'store'
import auth0 from 'auth0-js'
import { AUTH_CONFIG, FRONTDESK_AUTH_CONFIG, META_DATA_PREFIX } from '../config/auth0'
import { FRONTDESK_STORAGE_USER, LOCAL_STORAGE_AUTH_KEY,LOCAL_STORAGE_EXPEDITED_SIGNUP,LOCAL_STORAGE_GOOGLE_SIGNIN,LOCAL_STORAGE_GROUP_ID,/* , LOCAL_STORAGE_SESSION_TAG_KEY, LOCAL_STORAGE_NEW_ORGANIZATION_KEY */ 
LOCAL_STORAGE_STUDY_ID} from '../config/constants'
import { SIGN_UP_STEPS, USER_FORM_NAME } from '../config/form-settings'
import { checkShareLink } from '../utils/helpers'
import { getStore } from '../store/configureStore'
import { postAssignGroupRequest, postCreateGroupRequest } from '../actions/groupActions'
import { putStudyShareRequest } from '../actions/studyActions'
import { isEmpty } from 'lodash'
import { patchUserProfileRequest, patchUserRequest, postUserTypeRequest } from '../actions/userTypeActions'
import { getFormValues } from 'redux-form'
import { message } from 'antd'


export default class Auth {
  constructor () {
    this.auth0 = new auth0.WebAuth(AUTH_CONFIG)
    this.auth02 = new auth0.WebAuth(FRONTDESK_AUTH_CONFIG)
    this.login = this.login.bind(this)
    this.loginWithGoogle = this.loginWithGoogle.bind(this)
    this.logout = this.logout.bind(this)
    this.handleAuthentication = this.handleAuthentication.bind(this)
    this.getNewTokensForAPI = this.getNewTokensForAPI.bind(this)
    this.isAuthenticated = this.isAuthenticated.bind(this)
    this.makeCallToUserInfo = this.makeCallToUserInfo.bind(this)
    this.makeCallToCheckSession = this.makeCallToCheckSession.bind(this)
    this.updateUserAppMetadataInLocalStorage = this.updateUserAppMetadataInLocalStorage.bind(this)
    this.signUp = this.signUp.bind(this)
    this.getUserProfile = this.getUserProfile.bind(this)
    this.updateUserProfile = this.updateUserProfile.bind(this)
    this.isExpeditedSignupFlow = this.isExpeditedSignupFlow.bind(this)
    this.getExpeditedSuccessPath = this.getExpeditedSuccessPath.bind(this)
  }
  

  signUp (payload, callback) {
    payload.connection = 'TeleRadUsers'
    const urlParams = store.get(FRONTDESK_STORAGE_USER);
    if(urlParams){
      this.auth02.signup(payload, callback)
    }else {
      this.auth0.signup(payload, callback)
    }
  }

  signupAndAuthorize (payload, callback) {
    payload.connection = 'TeleRadUsers'
    this.auth0.signupAndAuthorize(payload, callback)
  }

  async makeCallToCheckSession () {
    return new Promise((resolve, reject) => this.auth0.checkSession(
      {
        audience: AUTH_CONFIG.audience,
        scope: AUTH_CONFIG.scope
      }, (error, result, response) => {
        if (error) {
          reject(error)
        } else {
          resolve(result, response)
        }
      })
    )
  }

  async getNewTokensForAPI () {
    try {
      const result = await this.makeCallToCheckSession()
      const { accessToken, idToken, state } = result
      store.set(LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN, accessToken)
      store.set(LOCAL_STORAGE_AUTH_KEY.ID_TOKEN, idToken)
      store.set(LOCAL_STORAGE_AUTH_KEY.STATE, state)
      return accessToken
    } catch (e) {
      console.error('ERROR: ', e)
      // checkSession often fails immediately after a fresh Auth0 login (SSO cookie /
      // silent-auth timing). If we already have a valid token from setSession, keep
      // using it instead of logging the user out mid-flow.
      const existingToken = store.get(LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN)
      if (existingToken && this.isAuthenticated()) {
        return existingToken
      }

      // Capture before logout — store.clearAll() wipes the expedited flag.
      const expeditedType = localStorage.getItem(LOCAL_STORAGE_EXPEDITED_SIGNUP)
      const isExpeditedSignup = Boolean(expeditedType) && expeditedType !== 'null'
      const postLoginTarget = store.get(LOCAL_STORAGE_AUTH_KEY.POST_LOGIN_TARGET)
      const isExpeditedTarget = typeof postLoginTarget === 'string' &&
        postLoginTarget.indexOf('/expedited-signup/') === 0
      this.logout()
      message.error('There was an error with your session. Please try again.')
      // Never dump expedited users onto /signup/account — SignUpContainer bounces
      // unauthenticated account visits to /signup/user-type.
      if (isExpeditedSignup || isExpeditedTarget) {
        history.replace(`/expedited-signup/${SIGN_UP_STEPS['expedited-success'].path}`)
      } else {
        history.push(`/signup/${SIGN_UP_STEPS['account'].path}`)
      }
    }
  }

  /**
   * True when this login belongs to the expedited signup funnel.
   * LOCAL_STORAGE_EXPEDITED_SIGNUP is written as the string "null" by older code
   * via localStorage.setItem(..., null) — treat that as unset.
   */
  isExpeditedSignupFlow (postLoginTarget) {
    const expeditedType = localStorage.getItem(LOCAL_STORAGE_EXPEDITED_SIGNUP)
    const hasExpeditedFlag = Boolean(expeditedType) && expeditedType !== 'null'
    const hasExpeditedTarget = typeof postLoginTarget === 'string' &&
      postLoginTarget.indexOf('/expedited-signup/') === 0
    return hasExpeditedFlag || hasExpeditedTarget
  }

  getExpeditedSuccessPath () {
    return `/expedited-signup/${SIGN_UP_STEPS['expedited-success'].path}`
  }

  updateUserAppMetadataInLocalStorage (appMetadata) {
    let currentProfileInStorage = store.get(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE)
    currentProfileInStorage[META_DATA_PREFIX + 'app_meta_data'] = appMetadata
    store.set(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE, currentProfileInStorage)
  }

  getUserAppMetadata () {
    let currentProfileInStorage = store.get(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE)
    if (!currentProfileInStorage) return null
    return currentProfileInStorage[META_DATA_PREFIX + 'app_meta_data']
  }

  async makeCallToUserInfo (accessToken) {
    return new Promise((resolve, reject) => this.auth0.client.userInfo(
      accessToken
      , (error, response) => {
        if (error) {
          reject(error)
        } else {
          resolve(response)
        }
      })
    )
  }

  async updateUserProfile (accessToken) {
    try {
      const response = await this.makeCallToUserInfo(accessToken)
        .then((user) => {
          store.set(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE, user)
          return user
        })
      return response
    } catch (error) {
      return error
    }
  }

  getProfileRequestBodyForUpdate () {
    const userProfile = this.getUserProfile()
    if (!userProfile) {
      return null
    }
    const { email, email_verified: emailVerified, name, nickname, picture, sub } = userProfile
    const appMetaData = userProfile && userProfile[META_DATA_PREFIX + 'app_meta_data']
    const userMetaData = userProfile && userProfile[META_DATA_PREFIX + 'user_meta_data']
    return {
      email,
      email_verified: emailVerified,
      name,
      nickname,
      picture,
      sub,
      user_metadata: userMetaData,
      app_metadata: appMetaData
    }
  }

  login (username, password, postLoginTarget) {
    store.set(LOCAL_STORAGE_AUTH_KEY.POST_LOGIN_TARGET, postLoginTarget)
    store.set(LOCAL_STORAGE_AUTH_KEY.USER_PASS, password)
    this.auth0.login({
      realm: 'TeleRadUsers',
      username,
      password
    }, (err) => {
      if (err) {
        console.error('Auth0 login error:', err)
        message.error(err.description || 'Login failed. Please try again.')
      }
    })
  }

  loginWithGoogle (user, postLoginTarget) {
    // Persist redirect target before Auth0 leaves the origin. Without this,
    // Google expedited signup has no POST_LOGIN_TARGET after callback.
    if (postLoginTarget) {
      store.set(LOCAL_STORAGE_AUTH_KEY.POST_LOGIN_TARGET, postLoginTarget)
    } else if (this.isExpeditedSignupFlow()) {
      store.set(LOCAL_STORAGE_AUTH_KEY.POST_LOGIN_TARGET, this.getExpeditedSuccessPath())
    }
    this.auth0.authorize({
      connection: 'google-oauth2',
      appState: {
        user,
        isGoogleLogin: true
      }
    })
  }

  handleAuthentication () {
    // Route render calls this on every paint. parseHash must only run once or the
    // second empty-hash call alerts and can interrupt setSession navigation.
    if (this._authHashHandled) return
    if (!/access_token|id_token|error/.test(window.location.hash)) return
    this._authHashHandled = true
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult, true)
      } else if (err) {
        this._authHashHandled = false
        console.log(err)
        window.alert(`Error: ${err.error}. Check the console for further details.`)
      }
    })
  }

  setSession (authResult, login) {
    // Set the time that the access token will expire at
    let expiresAt = (authResult.expiresIn * 1000) + new Date().getTime()
    store.set(LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN, authResult.accessToken)
    store.set(LOCAL_STORAGE_AUTH_KEY.ID_TOKEN, authResult.idToken)
    store.set(LOCAL_STORAGE_AUTH_KEY.EXPIRES_AT, expiresAt)
    store.set(LOCAL_STORAGE_AUTH_KEY.STATE, authResult.state)
    store.remove(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE)
    this.auth0.client.userInfo(authResult.accessToken, (err, user) => {
      if (!err) {
        const reduxStore = getStore()
        let postLoginTarget = store.get(LOCAL_STORAGE_AUTH_KEY.POST_LOGIN_TARGET)
        const isExpeditedSignup = this.isExpeditedSignupFlow(postLoginTarget)

        if (authResult.appState?.isGoogleLogin) {
          const updateObj = {
            userEmail: user.email,
            userFullName: user.name,
            contractType: authResult.appState.user.looking
              ? authResult.appState.user.looking
              : authResult.appState.user.contractType
                ? authResult.appState.user.contractType
                : 'Radiologist',
            title: authResult.appState.user.title ?? '',
            sub: user.sub
          }
          // Expedited Google signup must land on success, not medical-groups.
          const googleLink = isExpeditedSignup
            ? this.getExpeditedSuccessPath()
            : postLoginTarget
          reduxStore.dispatch(patchUserProfileRequest({
            user: updateObj,
            ...(googleLink ? { link: googleLink } : {})
          }))
        }
        store.set(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE, user)
        const isShareLink = checkShareLink()

        if (isExpeditedSignup) {
          postLoginTarget = this.getExpeditedSuccessPath()
          store.set(LOCAL_STORAGE_AUTH_KEY.POST_LOGIN_TARGET, postLoginTarget)
        } else if (!postLoginTarget) {
          postLoginTarget = `/signup/${SIGN_UP_STEPS['medical-groups'].path}`
        }

        if (isShareLink) {
          const studyId = store.get(LOCAL_STORAGE_STUDY_ID) || null

          if (studyId) {
            reduxStore.dispatch(putStudyShareRequest({ guid: studyId }))
          }

          // Share-link path used to skip navigation entirely, leaving users stuck on
          // /auth0-callback (or bouncing back to /expedited-signup/account via history).
          // Create the group in the background, then always navigate.
          reduxStore.dispatch(postCreateGroupRequest({
            userGroupName: `${user.email}'s Medical Group`,
            isExpedite: true,
            // Group saga must not fight the redirect we perform here.
            redirect: true
          }))
        } else {
          reduxStore.dispatch(patchUserRequest())
        }

        if (login) {
          history.replace(postLoginTarget)
        }
      }
    })
  }

  logout () {
    // window.localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE)
    // window.localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN)
    // window.localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY.ID_TOKEN)
    // window.localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY.EXPIRES_AT)
    // window.localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY.POST_LOGIN_TARGET)
    // window.localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY.MGMT_ACCESS_TOKEN)
    // window.localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY.MGMT_ID_TOKEN)
    // window.localStorage.removeItem(LOCAL_STORAGE_SESSION_TAG_KEY)
    // window.localStorage.removeItem(LOCAL_STORAGE_NEW_ORGANIZATION_KEY)
    store.clearAll()
  }

  getUserProfile () {
    // const profileValueFromStorage = store.get(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE)
    const profile = store.get(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE)
    return profile
  }

  refreshToken () {
    this.auth0.checkSession({}, (err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult, true)
      } else if (err) {
        window.alert(`Error: ${err.error}. Check the console for further details.`)
      }
    })
  }

  async getNewToken () {
    const response = await this.auth0.checkSession({}, (err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult, true)
      } else if (err) {
        window.alert(`Error: ${err.error}. Check the console for further details.`)
      }
    })

    return response
  }

  isAuthenticated () {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = store.get(LOCAL_STORAGE_AUTH_KEY.EXPIRES_AT)
    return new Date().getTime() < expiresAt
  }
}
